import React, { useContext, useReducer, useLayoutEffect } from "react";

import { reducer } from "src/reducers/high_risk/highriskReducer";
import _ from "lodash";
import * as API from "src/api/request";
import moment from "moment";
import { useUserContext } from "src/contexts/userContext";

const context = React.createContext();

const _state = {
  date: moment(),
  department: null,
  list_department: [],
  list_filter: [],
  refresh: 0,

  register: {
    department: null,
    modal: false,
    modal_approve: false,
    approve_type_id: 0,
    approve_comment: null,
    yearc: moment(),
    id: 0,
    type_id: 0,
    tseh_code: null,
    tseh_name: null,
    negj_code: null,
    negj_name: null,
    department_code: null,
    department_name: null,
    jobdesc: null,
    comment: null,

    selected_consequence: null,
    selected_probability: null,
    matrix_score: null,
    matrix_grade: null,
    matrix_id: 0,
  },

  list: {
    modal: false,
    job_id: 0,
    comment: null,
    exec: null,
  },
};

export const useHighRiskContext = () => {
  const ctx = useContext(context);
  if (ctx === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return ctx;
};

const Context = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, _state);
  const { user, checkGroup } = useUserContext();

  useLayoutEffect(() => {
    user.is_emc &&
      API.getUserDepartment().then((res) => {
        var result = [];

        if (!checkGroup([179, 374, 182]))
          result.push({
            departmentname: "Бүгд",
            departmentcode: 0,
            title: "Бүгд",
            departmentlevelid: 3,
            key: 0,
            value: 0,
            id: 0,
            pId: null,
            selectable: true,
          });

        _.map(
          _.orderBy(res, ["departmentlevelid", "departmentcode"]),
          (item) => {
            result.push({
              ...item,
              title: item.departmentcode + " | " + item.departmentname,
              key: item.id,
              value: item.id,
              id: item.id,
              pId: item.parentid,
              selectable: item.departmentlevelid !== -1,
            });
          }
        );
        result = _.filter(
          result,
          (a) => a.departmentlevelid > 1 && a.departmentlevelid < 5
        );
        dispatch({
          type: "STATE",
          data: {
            list_department: result,
          },
        });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <context.Provider value={{ state: state, dispatch: dispatch }}>
      {children}
    </context.Provider>
  );
};
export default React.memo(Context);
